<template>
  <div class="body">
    <div class="top">
      <div style="width: 45%" class="top_content">
        <el-card class="box-card">
          <announcement />
        </el-card>
      </div>
      <div style="width: 55%" class="top_content">
        <el-card class="box-card">
          <message />
        </el-card>
      </div>
    </div>

    <div class="main" style="margin-top: 20px">
      <el-card>
        <el-form ref="form" label-width="80px">
          <el-row :gutter="20">
            <el-col :span="8" :xs="24">
              <el-form-item label="环节名称">
                <el-input v-model="form.name" placeholder="请输入环节名称" />
              </el-form-item>
            </el-col>
            <el-col :span="6" :xs="24">
              <el-button type="primary" size="medium" @click="query()">查询</el-button>
              <el-button size="medium" @click="reset()">重置</el-button>
            </el-col>
          </el-row>
        </el-form>
        <el-tabs v-model="activeName">
          <el-tab-pane label="待办任务" name="todo">
            <el-table :data="todoList" max-height="540" style="width: 100%">
              <el-table-column prop="procDefName" label="流程名称">
              </el-table-column>
              <el-table-column prop="taskName" label="当前环节">
              </el-table-column>
              <!-- <el-table-column fixed prop="date" label="系统编号" width="180">
                <template slot-scope="scope">
                  <span>{{ scope.row.systemCode | code }}</span>
                </template>
              </el-table-column> -->
              <el-table-column prop="startTime" label="环节到达时间" width="160">
                <template slot-scope="scope">
                  <span>{{ scope.row.startTime | day }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="handlerCn" label="处理人" width="100">
              </el-table-column>
              <el-table-column prop="createUser" label="创建人" width="100">
              </el-table-column>
              <el-table-column prop="createTime" label="创建时间" width="160">
                <template slot-scope="scope">
                  <span>{{ scope.row.createTime | day }}</span>
                </template>
              </el-table-column>
              <el-table-column fixed="right" label="操作" width="80">
                <template slot-scope="scope">
                  <a @click="handleDone(scope)" style="color: #68ade9!important;font-size: 14px">去处理</a>
                </template>
              </el-table-column>
            </el-table>
            <div class="pages">
              <el-pagination v-show="wtotal > 0" :total="wtotal" :current-page="queryParams.pOffset"
                :page-size="queryParams.pLimit" layout="total, sizes, prev, pager, next, jumper" @size-change="sizeChange"
                @current-change="currentChange" />
            </div>
          </el-tab-pane>
          <el-tab-pane label="已办任务" name="done">
            <el-table :data="doneList" max-height="540" style="width: 100%">
              <el-table-column prop="procDefName" label="流程名称">
              </el-table-column>
              <el-table-column prop="taskName" label="当前环节">
              </el-table-column>
              <!-- <el-table-column fixed prop="date" label="系统编号" width="180">
                <template slot-scope="scope">
                  <span>{{ scope.row.systemCode | code }}</span>
                </template>
              </el-table-column> -->
              <el-table-column prop="startTime" label="环节到达时间" width="160">
                <template slot-scope="scope">
                  <span>{{ scope.row.startTime | day }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="handlerCn" label="处理人" width="100">
              </el-table-column>
              <el-table-column prop="endTime" label="环节完成时间" width="160">
              </el-table-column>
              <el-table-column prop="createUser" label="创建人" width="100">
              </el-table-column>
              <el-table-column prop="createTime" label="创建时间" width="160">
                <template slot-scope="scope">
                  <span>{{ scope.row.createTime | day }}</span>
                </template>
              </el-table-column>
              <el-table-column fixed="right" label="操作" width="80">
                <template slot-scope="scope">
                  <el-link v-if="scope.row.systemCode === 'HANYANG_HR'" :href="scope.row.detailPage + '&token=' + token" style="color: #68ade9!important;font-size: 14px" target="_blank">详情</el-link>
<!--                  <a href="{{scope.row.detailPage + '?token=' + token}}" target="_blank" style="color: #68ade9!important;font-size: 14px">详情</a>-->
                  <a v-else @click="handleDetail(scope)" style="color: #68ade9!important;font-size: 14px">详情</a>
                </template>
              </el-table-column>
            </el-table>
            <div class="pages">
              <el-pagination v-show="dtotal > 0" :total="dtotal" :current-page="queryParams.pOffset"
                :page-size="queryParams.pLimit" layout="total, sizes, prev, pager, next, jumper" @size-change="sizeChange"
                @current-change="currentChange" />
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </div>
  </div>
</template>
<script>
import Announcement from './Announcement'
import Message from './Message'
import { getDone, getTodo } from '../../api/home'
export default {
  name: 'Homepage',
  components: {
    Announcement,
    Message
  },
  props: {
    floatStatus: {
      type: String,
      default: () => ''
    }
  },
  data () {
    return {
      // 总条数
      dtotal: 1,
      wtotal: 1,
      queryParams: {
        pLimit: 10,
        pOffset: 1,
        handlerLoginName: ''
      },
      doneList: [
      ],
      todoList: [],
      form: {
        name: ''
      },
      activeName: 'todo',
      token: null
    }
  },
  created () {
    this.getList()
    this.token = JSON.parse(localStorage.getItem('Authorization')).val
  },
  methods: {
    getList () {
      // 待办任务
      this.queryParams.handlerLoginName = JSON.parse(localStorage.getItem('loginName')).val
      console.log(this.queryParams)
      getTodo(this.queryParams).then(res => {
        this.todoList = res.data.records
        this.wtotal = res.data.total
      })
      // 已办任务
      getDone(this.queryParams).then(res => {
        this.doneList = res.data.records
        this.dtotal = res.data.total
      })
    },
    currentChange (data) {
      console.log(data)
      this.queryParams.pOffset = data
      this.getList()
    },
    sizeChange (data) {
      console.log(data)
      this.queryParams.pLimit = data
      this.getList()
    },
    handleDone (scope) {
      const row = { ...scope.row }
      this.$router.push({
        path: '/system',
        query: {
          url: row.handlePage,
          urlType: '1'
        }
      })
    },
    handleDetail (scope) {
      const row = { ...scope.row }
      this.$router.push({
        path: '/system',
        query: {
          url: row.detailPage,
          urlType: '1'
        }
      })
    },
    query () {
      this.queryParams.taskName = this.form.name
      this.getList()
    },
    reset () {
      this.form.name = ''
      this.queryParams = {}
      this.getList()
    }
  }
}
</script>
<style  scoped>
.body {
  width: 100%;
  /* display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between; */
}

.body .top {
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.body .top .top_content {
  width: max-content;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.body .top .top_content .text {
  font-size: 14px;
}

.body .top .top_content .item {
  margin-bottom: 14px;
}

.body .top .top_content .box-card {
  width: 100%;
  margin: 0 10px;
  background-color: #fff;
}

.body .main {
  padding: 10px;
  box-sizing: border-box;
}

.body .main .el-tabs__nav-wrap {
  overflow: hidden;
  margin-bottom: -1px;
  position: relative;
  background-color: #409eff;
  border-radius: 20px;
  padding: 0 10px;
}

.body .main .el-tabs__item.is-active {
  color: #fff;
}

.body .main .el-tabs__nav-wrap::after {
  content: none;
  background-color: #fff;
}

.body .main .el-tabs__item {
  color: #303133;
}

.body .main .el-tabs__item:hover {
  color: #fff;
}

.body .pages {
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: right !important;
}

.dark {
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.dark .top {
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.dark .top .top_content {
  width: max-content;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.dark .top .top_content .text {
  font-size: 14px;
}

.dark .top .top_content .item {
  margin-bottom: 14px;
}

.dark .top .top_content .box-card {
  width: 100%;
  margin: 0 10px;
  background-color: #fff;
}

.dark .main {
  padding: 10px;
  box-sizing: border-box;
}

.dark .el-tabs__nav-wrap {
  overflow: hidden;
  margin-bottom: -1px;
  position: relative;
  background-color: #409eff;
  border-radius: 20px;
  padding: 0 10px;
}

.dark .el-tabs__item.is-active {
  color: #fff;
}

.dark .el-tabs__nav-wrap::after {
  content: none;
  background-color: #fff;
}

.dark .el-tabs__item {
  color: #303133;
}

.dark .el-tabs__item:hover {
  color: #fff;
}

.dark .pages {
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: right !important;
}
</style>



// WEBPACK FOOTER //
// src/views/components/HomePage.vue